import { IWarrantyOnAutoParts } from "api/interfaces/static-pages/warranty-on-auto-parts.type";
import Index from "container/warranty-policy/warranty-policyV2.container";

export default function WarrantyPolicy(props: IWarrantyOnAutoParts) {
  return <Index {...props} />;
}
